import { ApiProperty } from '@nestjs/swagger';

export class VdPdfDescuentoItemDto {
  @ApiProperty({ example: 'OS-1234' })
  os!: string;

  @ApiProperty({ example: 'Venta' })
  servicio!: string;

  @ApiProperty({ example: '2025-02-10' })
  fecha!: string;

  @ApiProperty({ example: 'TRHU897019' })
  contenedor!: string;

  @ApiProperty({ example: 95.0 })
  montoUsd!: number;

  @ApiProperty({ example: 951 })
  tc!: number;

  @ApiProperty({ example: 90365 })
  montoClp!: number;
}

export class VdPdfDescuentoTablaDto {
  @ApiProperty({ type: [VdPdfDescuentoItemDto] })
  items!: VdPdfDescuentoItemDto[];

  @ApiProperty({ example: 0 })
  totalUsd!: number;

  @ApiProperty({ example: 0 })
  totalClp!: number;
}

export class LiquidacionVdPdfPage3Dto {
  @ApiProperty({ description: 'Descuentos netos (TipoFacturacionId = 2)' })
  descuentosNetos!: VdPdfDescuentoTablaDto;

  @ApiProperty({
    description:
      'Descuentos por instrucción financiera (TipoFacturacionId = 1)',
  })
  instruccionFinanciera!: VdPdfDescuentoTablaDto;
}
